import React from 'react';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  reviewsPageAdditionalMeta,
  reviewsPageStructuredData,
} from '../../utils/data/MetaData';
import ReviewsPageMainContainer from '../../components/reviews/ReviewsPageMainContainer';

function ReviewsPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Reviews'
        desc={`Read reviews and testimonials about ${CompanyName}. Discover real client feedback on bespoke sessions and professional experiences.`}
        keywords={`${CompanyName}, reviews, testimonials, client feedback, BDSM, dominatrix experiences, ${KeywordsPages}`}
        additionalMeta={reviewsPageAdditionalMeta}
        structuredData={reviewsPageStructuredData}
      />

      {/* Page */}
      <div className='grid overflow-hidden min-h-screen text-colour1 dark:text-colour1 bg-colour2 dark:bg-colour2 font-poppins no__highlights'>
        <div className='grid grid-rows-reg'>
          <div>
            {/* Navigation */}
            <Navbar />

            <header className='grid w-full py-12'>
              <div className='grid place-items-center text-center px-8 md:px-12 lg:px-44'>
                {/* Main Header */}
                <section className='grid gap-y-4'>
                  <article className='grid gap-y-2 h-fit'>
                    <h1 className='text-4xl md:text-5xl lg:text-6xl font-kugile text-[#d9d9d9]'>
                      Mistress Diva
                    </h1>
                    <p className='uppercase tracking-wide text-sm md:text-base text-[#d9d9d9]'>
                      SUPREME GODDESS OF EROTIC ELEGANCE AND STERN DISCIPLINE
                    </p>
                    <p className='italic text-sm md:text-base text-[#d9d9d9]'>
                      "Your rightful place is here in My domain. Enter and let
                      Me turn your darkest desires into a reality"
                    </p>
                  </article>
                </section>
              </div>
            </header>
          </div>

          {/* Main page content */}
          <ReviewsPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default ReviewsPage;
